import React from 'react';
import type { FlexProps } from '@withjoy/joykit';
import { TextV2, Flex } from '@withjoy/joykit';
import type { DynamicBannerContent } from './useDynamicBanner.types';

interface DynamicBannerProps extends FlexProps {
  banner: DynamicBannerContent | null;
}

export const DynamicBanner = ({ banner, ...props }: DynamicBannerProps) => {
  if (!banner) return null;

  const Icon = banner.icon;

  return (
    <Flex
      backgroundColor="#4951EF"
      justifyContent="center"
      alignItems="center"
      gap={2}
      width="100%"
      paddingY={4}
      paddingX={9}
      {...props}
    >
      <Icon color="white" />
      <TextV2
        color="white"
        typographyVariant="hed2"
      >
        {banner.message}
      </TextV2>
    </Flex>
  );
};
